import { render, staticRenderFns } from "./entityDialogDisMenu.vue?vue&type=template&id=aa915872&scoped=true&"
import script from "./entityDialogDisMenu.vue?vue&type=script&lang=js&"
export * from "./entityDialogDisMenu.vue?vue&type=script&lang=js&"
import style0 from "./entityDialogDisMenu.vue?vue&type=style&index=0&id=aa915872&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa915872",
  null
  
)

export default component.exports